import groq from 'groq';
import sanityRequest from '@/sanity/requests/base';
import { PageAbout } from '@/types';

const query = groq`*[ _type == "about"][0] {
  _id,
  content,
  footer,
}`;

export default function getAbout() {
  const { sanity, store, data, loading, setData } = sanityRequest<PageAbout>();

  const about = store.state.pages.about;

  if (about) {
    setData(about);
  } else {
    sanity.client.fetch<PageAbout>(query).then((response) => {
      const about = {
        _id: response._id,
        content: response.content,
        footer: response.footer,
      } as PageAbout;
      store.commit.setPage('about', about);
      setData(about);
    });
  }

  return { data, loading };
}
